import { createFileRoute } from "@tanstack/react-router";

import NavBar from "#/components/navbar/navbar";
import Footer from "#/components/footer/footer";
import SearchBar from "#/components/searchbar";
import { organization } from "#/lib/jsonLdSchema";
import { metadataToHead, type PageMetadata } from "#/lib/seo";

export default function Page() {
  return (
    <>
      <header>
        <NavBar />
      </header>

      <main id="content" className="mx-auto mt-10 max-w-3xl space-y-10">
        <h1 className="mb-10 px-5 text-center text-5xl">
          Roamdoc Physician Job Search Engine
        </h1>

        <section className="mx-8 space-y-5">
          <SearchBar value="" />
        </section>
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={addJsonLd()}
      />
    </>
  );
}

export const metadata: PageMetadata = {
  title: "Search Physician Jobs in Anesthesiology Near You",
  description:
    "Find Physician Anesthesiologist jobs and hospitals hiring in the Texas, Florida, California, New York and all of U.S.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com`,
  },
};

function addJsonLd() {
  return {
    __html: `{
      "@context": "https://schema.org/",
      "@type": "WebSite",
      "@id": "https://www.roamdoc.com/#WebSite",
      "url": "https://www.roamdoc.com",
      "logo": "hhttps://www.roamdoc.com/roamdoc-logo.png",
      "inLanguage": "en-US",
      "name": "Roamdoc",
      "description": "Job search engine for physicians in anesthesiology.",
      "mainEntityOfPage": ${JSON.stringify(organization())},
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": "https://www.roamdoc.com/healthcare-job-search?q={search_term_string}"
        },
        "query-input": "required name=search_term_string"
      },
      "location": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "US"
        }
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "Customer Support",
        "url": "https://www.roamdoc.com/contact-roamdoc",
        "areaServed": "US",
        "availableLanguage": ["English", "Spanish"]
      },
      "copyrightYear": ${new Date().getFullYear()},
      "copyrightHolder": ${JSON.stringify(organization())}
    }`,
  };
}

export const Route = createFileRoute("/(job-search)/healthcare-job-search/")({
  component: Page,
  head: () => metadataToHead(metadata),
});
